/// <reference types="./createEntityEvent.d.ts" />
import { createEntityEvent } from '../utils/EventUtils.js';
export async function adminEntityCreateEntityEvent(database, context, event, syncEvent) {
    return await createEntityEvent(database, context, event.session, event.type, event.references.map(({ entityVersionInternalId, publishedName }) => ({
        entityVersionsId: entityVersionInternalId,
        publishedName,
    })), syncEvent);
}
//# sourceMappingURL=createEntityEvent.js.map